import { Party } from '@shared/party/models';
import { AppIcon, AppIconColor } from '@tablesready/frontend-icons';

export enum FloorPlanPartyTab {
  serving = 'Serving',
  waiting = 'Waiting',
  booked = 'Booked',
  all = 'All',
}

export interface FloorPlanPartyAction {
  action: (party: FloorPlanParty) => void;
  buttonStyle: string;
  buttonWidth?: number;
  title?: string;
  isDisabled?: (party: FloorPlanParty) => boolean;
  disabledTooltip?: string;
  tooltip?: string;
  icon?: AppIcon;
  color?: AppIconColor;
}

export interface PartyActionEvent {
  party: Party;
  cardType: FloorPlanPartyType;
  skipCheckServeTracking?: boolean;
  callback?: (createdParty: Party) => void;
  resourceId?: string;
  serveNow?: boolean;
  skipName?: boolean;
  showSuccessUpdateAlert?: boolean;
}

export enum FloorPlanPartyType {
  serving = 'Serving',
  waiting = 'Waiting',
  booked = 'Booked',
  checkedIn = 'Checked In',
  overdue = 'Overdue',
}

export interface FloorPlanParty extends Party {
  tabType: FloorPlanPartyTab;
  cardType: FloorPlanPartyType;
  actions: FloorPlanPartyAction[];
  resourceName: string;
}
